import Header from "@/components/header";
import Footer from "@/components/footer";
import Head from "next/head";
import MapBackground from "@/components/map-background";
export default function About() {
  return (
    <>
      <Head>
        <title>Partbot - About Us</title>
      </Head>
      <Header />
      <main>
        <div className="relative py-24 md:py-40">
          <div className="container mx-auto">
            <div className="prose prose-invert mx-auto max-w-prose px-6 text-sm text-emerald-300/60 md:px-6 md:text-base">
              <h2 className="bg-linear-to-br from-white to-stone-100 bg-clip-text text-3xl font-extrabold tracking-tight text-transparent md:text-5xl">
                About us
              </h2>
              <p>
                Partbot began as a humble data integration solution for SWD -
                Specialised Warehouse Distribution, a national warehousing and
                distribution company servicing the Australian automotive
                aftermarket.
              </p>
              <p>
                We needed a way to keep thousands of parts in sync with supplier
                catalogue data, inventory levels, pricing changes across
                multiple trade and retail websites as well as automating the
                fulfilment process.
              </p>
              <p>
                We realised Partbot was a product solution that could benefit
                many other Australian businesses—combining our product data
                sync, vehicle search plugins and decades of distribution and
                fulfilment experience.
              </p>
              <p>
                COVID-19 accelerated the demand for Partbot and the need for an
                Automotive Aftermarket wholesale fulfilment service, as many
                businesses were pivoting to or adding ecommerce sales channels
                and needed the tools and support to make a successful transition
                - Partbot now supports over 3000 Australian businesses who
                depend on fast, local, affordable parts fulfilment.
              </p>
              <p>
                We are now dedicated to building the best ecommerce tools and
                fulfilment solutions for the Australian automotive aftermarket.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
